import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveTable from './ResponsiveTable';

function ReviewTable({ data, totalCount, currentPage, pageSize }) {
  const navigate = useNavigate();
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toISOString().split('T')[0];
  };

  const columns = React.useMemo(
    () => [
      {
        Header: '순번',
        id: 'row',
        Cell: ({ row }) =>
          totalCount - ((currentPage - 1) * pageSize + row.index),
      },
      {
        Header: '커버',
        accessor: 'album.image',
        Cell: ({ row }) => (
          <img
            src={
              row.original.album?.image ||
              'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
            }
            alt={row.original.album?.nameKr || row.original.memberReviewAlbum?.albumName}
            className="w-12 h-12 rounded-full object-cover mx-auto shadow border border-white/[0.08]"
          />
        ),
      },
      {
        Header: '앨범명',
        accessor: 'album.nameKr',
        Cell: ({ row }) => {
          const isMemberApply = !!row.original.memberReviewAlbum;
          const name = row.original.album?.nameKr || row.original.memberReviewAlbum?.albumName || '';
          return (
            <div className="flex items-center gap-1.5">
              {isMemberApply && (
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 font-medium shrink-0">일반회원</span>
              )}
              <span
                className="font-bold text-sky-400 cursor-pointer hover:underline"
                onClick={() =>
                  navigate(`/ReviewViewPage/${row.original.id}?page=${currentPage}`)
                }>
                {name}
              </span>
            </div>
          );
        },
      },
      {
        Header: '아티스트',
        accessor: 'album.artist.nameKr',
        Cell: ({ row }) => row.original.album?.artist?.nameKr || row.original.memberReviewAlbum?.artistName || '',
      },
      {
        Header: '권리사',
        accessor: 'client.name',
        Cell: ({ row }) => row.original.client?.name || row.original.memberReviewAlbum?.clientName || '',
      },
      {
        Header: '신청일',
        accessor: 'createdAt',
        Cell: ({ row }) => formatDate(row.original.createdAt),
      },
      {
        Header: '진행상황',
        accessor: 'status',
        Cell: ({ row }) => {
          const details = row.original.reviewApplyDetails || [];
          const hasWaiting = details.some((d) =>
            d.reviewApplyResults.some((r) => r.status === 'WAITING')
          );
          const status = hasWaiting ? 'WAITING' : row.original.status;
          const label = status === 'Y' ? '심의완료' : '심의중';
          return (
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${
              status === 'Y' ? 'bg-sky-500/20 text-sky-400' : 'bg-rose-500/20 text-rose-400'
            }`}>
              <span className={`w-1.5 h-1.5 rounded-full animate-pulse ${status === 'Y' ? 'bg-sky-400' : 'bg-rose-400'}`} />
              {label}
            </span>
          );
        },
      },
    ],
    [navigate, totalCount, currentPage, pageSize]
  );

  return (
    <ResponsiveTable
      columns={columns}
      data={data}
      visibleOnMobile={[
        'row',
        'album.image',
        'album.nameKr',
        'album.artist.nameKr',
      ]}
    />
  );
}

export default ReviewTable;
